import { PAYMENT } from './order';

export const NOT_FOUND_INDEX = -1;

export const DAYS = {
  Monday: 'Lundi',
  Tuesday: 'Mardi',
  Wednesday: 'Mercredi',
  Thursday: 'Jeudi',
  Friday: 'Vendredi',
  Saturday: 'Samedi',
  Sunday: 'Dimanche',
};

export const ONLINE_PAYMENTS = [PAYMENT.TYPE_STRIPE];
